import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { literal } from "../../shared/src/codecs/types/literal";
import { union } from "../../shared/src/codecs/types/union";
import { requireExhaustive } from "../../shared/src/util";
import { TRoadblockType } from "../codecs/form/RoadblockForm";

export const RoadblockAssigneeRole = union([
    literal("case_handler"),
    literal("onboarding_manager"),
]);
export type TRoadblockAssigneeRoleCodec = typeof RoadblockAssigneeRole;
export type TRoadblockAssigneeRole = TTypeOfCodec<TRoadblockAssigneeRoleCodec>;

export const RoadblockAssigneeRole_displayString = (role: TRoadblockAssigneeRole): string =>
    role === "case_handler" ? "Case handler"
    : role === "onboarding_manager" ? "Onboarding manager"
    : requireExhaustive(role);

export type TRoadblockAssigneeRoleOverrides = Partial<Record<TRoadblockType, TRoadblockAssigneeRole>>;

export const DEFAULT_ONBOARDING_MANAGER_ROADBLOCK_TYPES: Array<TRoadblockType> = [
    "client_verification",
    "contract_ready",
    "pre_completion_ready",
    "quote",
    "chase_instruction",
];

export const defaultRoadblockAssigneeRole = (type: TRoadblockType): TRoadblockAssigneeRole =>
    DEFAULT_ONBOARDING_MANAGER_ROADBLOCK_TYPES.includes(type)
        ? "onboarding_manager"
        : "case_handler";

export const resolveRoadblockAssigneeRole = (
    overrides: TRoadblockAssigneeRoleOverrides,
    type: TRoadblockType,
): TRoadblockAssigneeRole =>
    overrides[type] ?? defaultRoadblockAssigneeRole(type);
